import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
  TextField,
  Button,
  Autocomplete,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseExpressDelivery } from "./UseExpressDelivery";
import { useSearchParams } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import EditIcon from "@mui/icons-material/Edit";
import { useSnackbar } from "notistack";
import ListAltIcon from "@mui/icons-material/ListAlt";
import RefreshIcon from "@mui/icons-material/Refresh";
import LogesticDetails from "./LogesticDetails";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";

export default function ExpressDetails() {
  const { enqueueSnackbar } = useSnackbar();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    updateAlopeykOrder,
    getExpressById,
    getOrderStates,
    cancelAlopeykOrder,
    getLogesticsPlatforms,
    getLogesticsDriver,
    createAlopeykOrder,
  } = UseExpressDelivery();
  const [detailRes, setDetailRes] = useState();
  const [openDialogUpdate, setOpenDialogUpdate] = useState({
    show: false,
    id: undefined,
    type: undefined,
  });
  const [openDialog, setOpenDialog] = useState({
    show: false,
    model: "",
    id: undefined,
  });
  const [orderStates, setOrderStates] = useState();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [state, setState] = useState({ id: undefined, state: undefined });
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const [platforms, setPlatforms] = useState();
  const [drivers, setDrivers] = useState();
  const [addState, setAddState] = useState({
    id: undefined,
    logesticID: undefined,
    driverID: undefined,
  });

  useEffect(() => {
    if (searchParams.get("oid")) {
      setProgress(true);
      getLogesticsPlatforms((platforms) => {
        setPlatforms(platforms);
      });
      getLogesticsDriver((drivers) => {
        setDrivers(drivers);
      });
      getOrderStates((states) => {
        setOrderStates(states);
      });
      getExpressById(searchParams.get("oid"), (details) => {
        setDetailRes(details);
      });
    }
  }, [searchParams]);

  const newFunc = () => {
    setOpenDialogUpdate({ show: true, type: "create", id: undefined });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "logesticName",
      headerName: "لجستیک",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.logesticName}
          </Typography>
        );
      },
    },
    {
      field: "shamsiLogdate",
      headerName: "ثبت",
      width: 160,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
              direction: "rtl",
              textAlign: "center",
            }}
          >
            {cellValues.row.shamsiLogdate}
          </Typography>
        );
      },
    },

    {
      field: "shamsiPicking",
      headerName: "ارسال",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl", textAlign: "center" }}
          >
            {cellValues.row.shamsiPicking}
          </Typography>
        );
      },
    },
    {
      field: "shamsiFinished",
      headerName: "تحویل",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl", textAlign: "center" }}
          >
            {cellValues.row.shamsiFinished}
          </Typography>
        );
      },
    },
    {
      field: "reciveEstimateTime",
      headerName: "تخمین",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl", textAlign: "center" }}
          >
            {cellValues.row.reciveEstimateTime}
          </Typography>
        );
      },
    },
    {
      field: "status",
      headerName: "وضعیت",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.status}
          </Typography>
        );
      },
    },
    {
      field: "operatorName",
      headerName: "اوپراتور",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.operatorName}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 110,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="جزئیات">
              <IconButton
                onClick={() => {
                  setOpenDialog({
                    show: true,
                    model: cellValues.row,
                    id: cellValues.row.id,
                  });
                }}
              >
                <ListAltIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            {cellValues.row.logesticID == 1 ? (
              <Tooltip title="ویرایش">
                <IconButton
                  onClick={() => {
                    setOpenDialogUpdate({
                      show: true,
                      id: cellValues.row.id,
                      type: undefined,
                    });
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="رفرش">
                <IconButton
                  onClick={() => {
                    setProgress(true);
                    let state = { id: cellValues.row.id };
                    updateAlopeykOrder(state, () => {
                      getExpressById(searchParams.get("oid"), (details) => {
                        setDetailRes(details);
                        setState({
                          id: undefined,
                          state: undefined,
                        });
                      });
                    });
                  }}
                >
                  <RefreshIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        backButtonDef: true,
        backURL: "/expressmanage",
        title: "لجستیک",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/expressmanage" },
          {
            name: "جزئیات سفارش " + "(" + searchParams.get("oid") + ")",
            url: "/expressmanage/orderDetail",
          },
        ],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        // maxWidth="lg"
        open={openDialogUpdate.show}
        onClose={() => {
          setOpenDialogUpdate({ show: false, id: undefined, type: undefined });
          setAddState({
            id: undefined,
            logesticID: undefined,
            driverID: undefined,
          });
          setState({
            id: undefined,
            state: undefined,
          });
        }}
      >
        <DialogContent>
          {openDialogUpdate.type && openDialogUpdate.type == "create" ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <Autocomplete
                size="small"
                value={addState.logesticID ? addState.logesticID : ""}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setAddState({
                      ...addState,
                      id: detailRes.id,
                      logesticID: newValue,
                      driverID: undefined,
                    });
                  } else {
                    setAddState({
                      ...addState,
                      logesticID: undefined,
                      driverID: undefined,
                    });
                  }
                }}
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option) {
                    return platforms?.find((m) => m.id == option).title;
                  }
                  return "";
                }}
                sx={{ width: "70%" }}
                fullWidth
                options={platforms ? platforms.map((m) => m.id) : []}
                renderInput={(params) => (
                  <TextField variant="outlined" {...params} label="لجستیک" />
                )}
              />
              {addState.logesticID && addState.logesticID == 1 && (
                <Autocomplete
                  size="small"
                  value={addState.driverID ? addState.driverID : ""}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setAddState({
                        ...addState,
                        id: detailRes.id,
                        driverID: newValue,
                      });
                    } else {
                      setAddState({ ...addState, driverID: undefined });
                    }
                  }}
                  isOptionEqualToValue={(option, value) => {
                    return value == "" || option === value;
                  }}
                  getOptionLabel={(option) => {
                    if (option) {
                      return drivers?.driver.find((m) => m.id == option).driver;
                    }
                    return "";
                  }}
                  sx={{ width: "70%" }}
                  fullWidth
                  options={drivers ? drivers.driver.map((m) => m.id) : []}
                  renderInput={(params) => (
                    <TextField variant="outlined" {...params} label="راکب" />
                  )}
                />
              )}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => {
                    if (!addState.logesticID) {
                      enqueueSnackbar("لطفا لجستیک را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    if (
                      addState.logesticID &&
                      addState.logesticID == 1 &&
                      !addState.driverID
                    ) {
                      enqueueSnackbar("لطفا راکب را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    setCheckState({
                      show: true,
                      name: "ایجاد سفارش",
                      type: "create",
                    });
                  }}
                >
                  ایجاد
                </Button>

                <Button
                  variant="outlined"
                  onClick={() => {
                    setOpenDialogUpdate({
                      show: false,
                      id: undefined,
                      type: undefined,
                    });
                    setAddState({
                      id: undefined,
                      logesticID: undefined,
                      driverID: undefined,
                    });
                  }}
                >
                  انصراف
                </Button>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
                width: "100%",
              }}
            >
              <Autocomplete
                size="small"
                value={state.state ? state.state : ""}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setState({
                      id: openDialogUpdate.id,
                      state: newValue,
                    });
                  } else {
                    setState({ ...state, state: undefined });
                  }
                }}
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option) {
                    return orderStates?.find((m) => m.id == option).title;
                  }
                  return "";
                }}
                sx={{ width: "70%" }}
                fullWidth
                options={orderStates ? orderStates.map((m) => m.id) : []}
                renderInput={(params) => (
                  <TextField variant="outlined" {...params} label="وضعیت" />
                )}
              />
              <Box>
                <Button
                  variant="contained"
                  onClick={() => {
                    if (!state.state) {
                      enqueueSnackbar("لطفا وضعیت را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    setCheckState({
                      show: true,
                      name: "ویرایش وضعیت سفارش",
                    });
                  }}
                >
                  ثبت
                </Button>
                <Button
                  sx={{ mx: 2 }}
                  variant="outlined"
                  onClick={() => {
                    setOpenDialogUpdate({
                      show: false,
                      id: undefined,
                      type: undefined,
                    });
                    setState({
                      id: undefined,
                      state: undefined,
                    });
                  }}
                >
                  انصراف
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setCheckState({
                      show: true,
                      name: "لغو سفارش",
                      type: "cancel",
                    });
                  }}
                >
                  لغو ارسال
                </Button>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        maxWidth="lg"
        open={openDialog.show}
        onClose={() => {
          setOpenDialog({ show: false, model: "", id: undefined });
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          <LogesticDetails
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            detailRes={detailRes?.logestic}
            callback={() => {
              getExpressById(searchParams.get("oid"), (details) => {
                setDetailRes(details);
              });
            }}
          />
        </DialogContent>
      </Dialog>
      <DataGrid
        className="ltr-grid"
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={detailRes?.logestic ? detailRes.logestic : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={
          detailRes?.logestic && detailRes?.logestic.length
            ? detailRes.logestic.length
            : 1
        }
        enableRangeSelection={true}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "&  .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "&  .MuiDataGrid-cell:focus-within ": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          "& .MuiDataGrid-cell:hover": {
            opacity: "80%",
            cursor: "pointer",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone": {
            width: "100% !important",
          },
          "& .Green": {
            backgroundColor: "#56ff004f !important",
          },
          "& .red": {
            backgroundColor: "#ff9c9c !important",
          },
        }}
        getRowClassName={(params) => {
          if (params.row.status == "تحویل شد") {
            return "Green";
          }
          if (params.row.status && params.row.status == "کنسل شد") {
            return "red";
          }
        }}
        componentsProps={{
          pagination: {
            isLtr: true,
            nofab: true,
            newFunc: newFunc,
            creatLogestic: true,
            rowCount:
              detailRes?.logestic && detailRes.logestic.length
                ? detailRes.logestic.length
                : "",
          },
        }}
      />
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          if (checkState.type == "create") {
            setProgress(true);

            createAlopeykOrder(addState, () => {
              setOpenDialogUpdate({
                show: false,
                id: undefined,
                type: undefined,
              });

              setAddState({
                id: undefined,
                logesticID: undefined,
                driverID: undefined,
              });
              getExpressById(searchParams.get("oid"), (details) => {
                setDetailRes(details);
              });
            });
          } else if (checkState.type == "cancel") {
            let cancelState = {
              id: openDialogUpdate.id,
            };
            setProgress(true);
            cancelAlopeykOrder(cancelState, () => {
              setOpenDialogUpdate({
                show: false,
                id: undefined,
                type: undefined,
              });

              setState({
                id: undefined,
                logesticID: undefined,
                driverID: undefined,
              });
              getExpressById(searchParams.get("oid"), (details) => {
                setDetailRes(details);
                setState({
                  id: undefined,
                  state: undefined,
                });
              });
            });
          } else {
            setProgress(true);
            updateAlopeykOrder(state, () => {
              setOpenDialogUpdate({
                show: false,
                id: undefined,
                type: undefined,
              });
              getExpressById(searchParams.get("oid"), (details) => {
                setDetailRes(details);
                setState({
                  id: undefined,
                  state: undefined,
                });
              });
            });
          }
        }}
      />
    </Detail>
  );
}
